<template>
  <div v-if="isShowContent">
    <div class="ccui-app-container-detail2">
      <div class="ccui-app-container-detail-body">
        <div class="ccui-top-title">基本信息</div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="160px"
          class="ccui-form"
        >
          <el-form-item label="公司名称：">
            {{ form.businessName }}
          </el-form-item>
          <el-form-item label="联系人：" v-if="form.contactStr">
            {{ form.contactStr }}
          </el-form-item>
          <el-form-item label="公司简称：" prop="businessShortname">
            <el-input
              clearable
              v-model.trim="form.businessShortname"
              class="input-long"
              placeholder="请输入公司简称"
              disabled
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="统一社会信用代码：" prop="unifiedCode">
            <span style="position: absolute; left: -127px; color: #f56c6c"
              >*</span
            >
            <el-input
              clearable
              v-model.trim="form.unifiedCode"
              @input="creditCodeChange"
              class="input-long"
              disabled
              placeholder="请输入统一社会信用代码"
              maxlength="18"
            />
          </el-form-item>
          <div class="ccui-top-title">店铺信息</div>
          <el-form-item label="商家名称：">
            {{ form.businessName }}
          </el-form-item>
          <el-form-item
            label="销售范围是否限制："
            prop="saleLimitFlag"
            class="input-center"
          >
            <el-radio-group
              v-model.trim="form.saleLimitFlag"
              @change="isLimit"
              disabled
            >
              <!-- :disabled="form.shopType == 6" -->
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <div class="tipRight">
              <el-popover placement="right-start" width="360" trigger="hover">
                <div class="introduce">
                  <div>
                    <span class="textOfw"
                    >请选择合作协议中的商品品类/适用单位/适用区域</span
                    >
                  </div>
                </div>
                <!-- <img
                  slot="reference"
                  class="hoverHelp"
                  style="height: 18px; width: 18px"
                  :src="helpImg"
                  alt=""
                /> -->
                <i slot="reference" class="icon-ccui-help" style="font-size: 16px;color:#538cec"></i>
              </el-popover>
            </div>
          </el-form-item>
          <div
            v-if="form.saleLimitFlag == 1"
            style="background-color: #F2F2F2;padding:  20px 0 10px;width: 800px;margin-bottom: 20px"
          >
              <el-form-item
                v-if="form.saleLimitFlag == 1"
                label="销售品类选择："
                prop="salesCategory"
              >
                <span style="position: absolute; left: -100px; color: #f56c6c"
                  >*</span
                >
                <el-checkbox
                  style="opacity: 0; position: absolute"
                  v-model.trim="form.salesCategory"
                ></el-checkbox>
                <div class="category-input-wrapper">
                  <div
                    :class="
                  salesCategory[0].categoryName !== '请选择'
                    ? 'category selectClass'
                    : 'category'
                "
                  >
                    <div v-for="(item, idx) in salesCategory" :key="idx">
                      {{ item.categoryName }}
                    </div>
                  </div>
                  <el-button
                    size="mini"
                    type="primary-font-mini"
                    @click="$refs.salesCategory.open()"
                    :disabled="[1, 3].includes(form.contractCommonShopBO.contractCheckState)"
                  >选择类目</el-button
                  >
                </div>
              </el-form-item>
              <el-form-item
                v-if="form.saleLimitFlag == 1"
                label="适用范围选择："
                prop="scopeData"
              >
                <span style="position: absolute; left: -100px; color: #f56c6c"
                  >*</span
                >
                <div class="category-input-wrapper">
                  <el-checkbox
                    style="opacity: 0; position: absolute"
                    v-model.trim="form.scopeData"
                  ></el-checkbox>
                  <div
                    :class="
                  scopeData[0].scopeDataName !== '请选择'
                    ? 'category selectClass'
                    : 'category'
                "
                  >
                    <div v-for="(item, idx) in scopeData" :key="idx">
                      {{ item.scopeDataName }}
                    </div>
                  </div>
                  <el-button
                    size="mini"
                    type="primary-font-mini"
                    @click="$refs.staffSelector.showDialogInventory()"
                    :disabled="[1, 3].includes(form.contractCommonShopBO.contractCheckState)"
                  >选择范围</el-button
                  >
                </div>
              </el-form-item>
              <el-form-item
                v-if="form.saleLimitFlag == 1"
                label="适用地区："
                prop="areaData"
              >
                <span style="position: absolute; left: -75px; color: #f56c6c"
                  >*</span
                >
                <div class="category-input-wrapper">
                  <el-checkbox
                    style="opacity: 0; position: absolute"
                    v-model.trim="form.areaData"
                  ></el-checkbox>
                  <div
                    :class="
                  areaData[0].areaDataName !== '请选择'
                    ? 'category selectClass'
                    : 'category'
                "
                  >
                    <div v-for="(item, idx) in areaData" :key="idx">
                      {{ item.areaDataName }}
                    </div>
                  </div>
                  <el-button
                    size="mini"
                    type="primary-font-mini"
                    @click="selectRegionClick"
                    :disabled="[1, 3].includes(form.contractCommonShopBO.contractCheckState)"
                  >选择地区</el-button
                  >
                </div>
              </el-form-item>
            </div>

          <el-form-item label="经营类目：" prop="categoryData">
            <el-checkbox
              style="opacity: 0; position: absolute"
              v-model.trim="form.categoryData"
            ></el-checkbox>
            <div class="category-input-wrapper">
              <div
                :class="
                  categoryData[0].categoryName !== '请选择经营类目'
                    ? 'category selectClass'
                    : 'category'
                "
              >
                <div v-for="(item, idx) in categoryData" :key="idx">
                  {{ item.categoryName }}
                </div>
              </div>
              <el-button
                size="mini"
                type="primary-font-mini"
                @click="selectCategoryClick"
                :disabled="form.shopType == 6"
                >选择类目</el-button
              >
            </div>
          </el-form-item>
          <el-form-item
            class="input-center"
            label="合作类型："
            prop="cooperationType"
          >
            <el-checkbox-group
              v-model.trim="cooperationType"
              disabled
              :max="1"
            >
              <el-checkbox label="4">撮合</el-checkbox>
              <el-checkbox label="5">第三方</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="店铺类型：" prop="shopType" class="input-center">
            <el-radio-group v-model.trim="form.shopType" disabled>
              <el-radio :label="10">平台撮合店</el-radio>
              <el-radio :label="11">平台三方店</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="店铺名称：" prop="shopName">
            <el-input
              maxlength="30"
              clearable
              v-model="form.shopName"
              @blur="allStrTrim('shopName')"
              class="input-long"
              placeholder="请输入店铺名称"
            />
            <div class="noteBusinessName">
              {{ shoTypeArr[form.shopType] }}
            </div>
          </el-form-item>
          <el-form-item label="店铺编号：">
            {{ shopCode }}
          </el-form-item>
          <el-form-item
            label="店铺LOGO："
            class="uploadNoteWrapper"
            prop="skuNum"
          >
            <el-upload
              class="avatar-uploader"
              :action="baseUrl + '/apis/sra/reg/users/signup/uploadFileToOssByShopLoGo'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="icon-ccui-camera"></i>
              <div v-if="!imageUrl">上传logo</div>
              <div
                v-if="imageUrl"
                class="logo-upload-box-img-close"
                @click.stop="onFileDelete"
              >
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAB9klEQVQ4T3WST6hSQRTGv5muxcWFoiAlgs9WEYKvRdHORbsEEZQgbRUYbotAuSLchfe68a0jKALbujBzEYIIbso/UCLI24mS4k6DcnN1TtwLivh4s5qZc37nfN/MYThauq7fJ6LXAJ4A8BLRH875D875h1wu9/U4l+0PxWIxxxgrArhxnHC0/2IYxgtVVf+adxao6/obIrq4BoAkSdjtdhBCfNtutxFVVQUrlUpnQohLzvmtTCaDWq2GxWJxqOFwOJBKpdBoNDCbzcAYe6koyiem63qJiHJmZiAQQDQaRbVaxXw+h9PptKB+v49er7cv9iufzz9gmqZ9B/B4f+v3+xGLxdBqtRAOh9HtdjEYDA4KGGMky7LLBCcAzo79hUIhRCIRC2g2m1esS5J0zwR/AjjfR10ulyVvPB4jGAxanqfT6Sl82wTfAciYEbfbjWQyiU6ng+FwCJ/Ph3g8jnq9jsnEFGatST6fv2u+6kMhRFeWZZZOp9FutzEajQ4dvF4vEokEKpUK1uu1+aoFRVGK1j9qmvaec/7K4/FguVxe8WS327HZbEBE49Vq9ahcLv+zQFVVb9psts8Anl03BAAuhRBPC4WCpfkwcuZe07TnRPSWc35ORFaMMfabiD4ahlHej9speGim67qbiO5IkrTOZrNzAHSq5D8ce800Td7rRQAAAABJRU5ErkJggg=="
                  alt=""
                />
              </div>
            </el-upload>
            <div class="uploadNote">
              尺寸：高度60px 宽度200px以内，文件格式：png
            </div>
          </el-form-item>
          <el-form-item label="店铺经营地址：" prop="shopAddress">
            <el-input
              maxlength="200"
              clearable
              v-model="form.shopAddress"
              class="input-long"
              @blur="allStrTrim('shopAddress')"
              placeholder="请输入店铺经营地址"
            />
          </el-form-item>
          <el-form-item label="客服电话：" prop="supportPhone">
            <el-input
              maxlength="30"
              clearable
              @input="regSpace('supportPhone')"
              v-model.trim="form.supportPhone"
              class="input-long"
              placeholder="请输入客服电话"
            />
          </el-form-item>
          <el-form-item label="店铺简介：" prop="shopBrief">
            <el-input
              type="textarea"
              maxlength="1000"
              :autosize="{ minRows: 2, maxRows: 4 }"
              clearable
              @blur="allStrTrim('shopBrief')"
              v-model="form.shopBrief"
              class="input-long"
              placeholder="请输入店铺简介"
            />
          </el-form-item>
          <div class="ccui-top-title">店长信息</div>
          <div style="height: 20px"></div>
          <el-form-item label="店长姓名：" prop="shopManager">
            <el-input
              maxlength="50"
              clearable
              @blur="allStrTrim('shopManager')"
              v-model="form.shopManager"
              class="input-long"
              placeholder="请输入店长的真实姓名"
            />
          </el-form-item>
          <el-form-item label="手机号码：" prop="shopManagerPhone">
            <el-input
              maxlength="11"
              clearable
              @input="regSpace('shopManagerPhone')"
              v-model.trim="form.shopManagerPhone"
              class="input-long"
              placeholder="请输入手机号码"
            />
            <p style="color: #FF142F; font-size: 12px; line-height: 22px">此手机号所属账号为后续店铺运营最高权限账号，请谨慎填写!</p>
          </el-form-item>
          <el-form-item label="E-mail地址：" prop="shopManagerEmail">
            <el-input
              maxlength="100"
              clearable
              v-model.trim="form.shopManagerEmail"
              class="input-long"
              placeholder="请输入E-mail地址"
            />
          </el-form-item>
          <template v-if="businessId != '4'">
            <div class="ccui-top-title">上传资质</div>
            <span class="file-type-lyp"
              >上传文件支持格式：.jpg .png .jpeg .gif每个不超过5M，.xls .xlsx .doc
              .docx .pdf每个不超过15M</span
            >
            <template v-if="isShowBusinessFile">
              <upload-templates
                :thisPage="thisPageName"
                ref="uploadTemplate"
                v-for="(item, idx) in titleData"
                :titleData="item"
                :key="idx"
                :isMarginIdx="idx"
              />
            </template>
            <div v-for="(item, idx) in addQuaTemplate" :key="item.id">
              <upload-templates
                :thisPage="thisPageName"
                ref="uploadTemplate"
                :titleData="item"
                :isMarginIdx="idx"
                @deleteClick="deleteClick"
              />
            </div>
            <div class="addQuaBtn" @click="addQuaBtn">
              <span><i class="icon-ccui-add"></i>添加资质</span>
            </div>
          </template>
          <div class="ccui-top-title">上传材料</div>
          <el-form-item label="邀请函附件：" prop="isfileBos">
            <el-input v-model="form.isfileBos" v-show="false"></el-input>
            <fileUpload
              @success="uploadSuccess"
              :limit="1"
              ref="fileUploadRef"
            >
              <template #downloadTemplate>
                <a class="template" target="_blank" :href="downFileUrl" download="邀请函附件模板.doc">
                  点击下载附件模板
                </a>
              </template>
            </fileUpload>
          </el-form-item>
          </el-form>
        <div class="footer-step-lyp">
          <el-button @click="nextClick" type="primary" style="width: 240px; font-weight: 600;height:40px">下一步</el-button>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>
    <salesCategory
      ref="salesCategory"
      :shopManageClassifyCodeBos="shopManageClassifyCodeBos"
      @mergedStringArray="mergedStringArray"
      @categoryCode="categoryCode"
    ></salesCategory>
    <staffSelector
      ref="staffSelector"
      selectedTitle="已选择部门"
      title="选择适用范围"
      :showBtnTest="false"
      :selectedData="selectedData"
      :requestTreeFunction="getQryOrgTree"
      :requestTreeFunction1="qryNonCCCCDeveloperInfo"
      :requestSeachFunction="queryMemberGroup"
      :singleChoice="false"
      @selectedStaffSuccess="selectedStaffSuccess"
    />
    <regionSelector
      ref="areaSelect"
      :dialogVisible.sync="dialogarea"
      :areaData="areaData"
      :checkedCitiesa="distributorsInfo"
      :url="url"
      :astrict="astrict"
      :agentId="agentId"
      @myCancel="handleAreaSelect"
    />
    <!-- 经营类目新的修改 -->
    <dialog-multi-checkbox-group
      ref="categoryData"
      :shopId="resultInfo.shopId"
      :shopInfo="shopInfo"
      :defaultPitchOn="defaultPitchOn"
      :agentId="agentId"
      :headers="headers"
      :dialogVisible.sync="dialogVisible"
      :shopType="form.shopType"
      @determine="determine"
      @refdata="refdata"
      :qryCategoryByCodeUrl="qryCategoryByCodeUrl"
      :qryFirstCategoryUrl="qryFirstCategoryUrl"
    >
    </dialog-multi-checkbox-group>
    <el-dialog
      title="电子账户服务协议"
      :visible.sync="agreementModal"
      width="700px"
      class="dialog-center"
      show-divider
      show-shadow
      :before-close="handleClose"
      custom-class="el-dialog--customize"
    >
      <div
        class="agreementModalCss"
        v-html="agreementContent.agreementContent"
      />
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="agreementModal = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import regionSelector from ".././components/areaSelection";
import DialogMultiCheckboxGroup from '../components/dialog-multi-checkbox-group'
import staffSelector from ".././components/staffSelector.vue";
import salesCategory from ".././components/salesCategory.vue";
import validators from "@/utils/validators";
import uploadTemplates from ".././components/upload-templates.vue";
import category from ".././components/category.vue";
import helpImg from "@/assets/images/help.png";
// import { getQryAptitude } from "@/api/category-view.js";
import { addShopByThreeParty, qryShopInfo,getQryOrgTree,queryMemberGroup,qryNonCCCCDeveloperInfo } from "@/api/apply-shop-edit.js";
import { getQryBusinessInfo, getQryBusinessInfoByTyc } from "@/api/input-business-info.js";
import agreementContent from "./agreement-content";
import fileUpload from "@/views/lessor-open-shop/apply/fileUpload";
import Cookies from "js-cookie";

//经营类目的混入
import ApplyShowCategory from "@/mixins/applay-show-category";
// import { _deepClone } from '@/utils/validate.js'

const validatorShopName = (rule, value, callback, _thisData) => {
  console.log(rule, value, callback, _thisData);
  if (value.length < 4) {
    callback(new Error("请按规则输入店铺名称"));
    return false;
  }
  let valueSub = value.substr(value.length - 3);
  if (valueSub === _thisData.shoTypeArr[_thisData.form.shopType]) {
    callback();
  } else {
    callback(new Error("请按规则输入店铺名称"));
  }
};

export default {
  name: "applyShopInfo",
  components: {
    uploadTemplates,
    category,
    salesCategory,
    staffSelector,
    regionSelector,
    DialogMultiCheckboxGroup,
    fileUpload,
  },
  //经营类目的混入
  mixins: [ApplyShowCategory],
  data() {
    let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    return {
      businessId:'',
      shopId:'',
      shopManageClassifyCodeBos:[],
      selectedData:[],
      classifyBos:[],//商品类目保存code
      categoryBos: [],
      dialogarea:false,
      distributorsInfo: [],
      url:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/store/users/signup/qryAddress",
      astrict: 2,
      /*---经营类目44444444---*/
      selectData: [],
      defaultPitchOn: [],
      //二级目录的数据接口
      qryCategoryByCodeUrl:
        baseUrl + "/apis/sra/store/users/signup/qryCategoryByCode",
      //一级目录的数据接口
      qryFirstCategoryUrl:
        baseUrl + "/apis/sra/store/users/signup/qryFirstCategory",
      agentId: "100020",
      headers: {
        APP_TOKEN: Cookies.get("appToken") || "",
      },
      /*---经营类目---*/
      shopCode: "",
      thisPageName: "applyShopInfo",
      agreementContent: agreementContent,
      electronicsAccount: true,
      shoTypeArr: {
        0: "命名规则：“企业商号+类目名+专营店”命名，不得以“XX(品牌名)专营店”命名。",
        1: "命名规则：以“品牌名+(类目名)+官方旗舰店/旗舰店”命名。",
        2: "命名规则：以“品牌名+企业商号+专卖店”命名，如为多个品牌的，以该专卖店主打品牌名/品牌综合性名称+企业商号+专卖店。",
        3: "命名规则：“企业商号+经营店”命名。",
        5: "命名规则：“企业商号+扶贫直销店”命名。",
      },
      isShowContent: true,
      keepAlive: [
        "business-shop-business-shop-children-apply-shop-input-business-info",
        "business-shop-business-shop-children-apply-shop-input-business-name",
        "business-shop-business-shop-children-apply-shop-input-business-info",
      ],
      baseUrl: baseUrl,
      imageUrl: "",
      helpImg: helpImg,
      typeTile:
        "以“XX（品牌名）旗舰店”命名，品牌名应为已经注册的商标（R状态）或正在受理注册中的商标（TM状态，注册申请时间须满六个月），卖家是该品牌（商标）的商标权利人，或卖家持有该品牌（商标）的权利人出具的在平台开设品牌旗舰店的授权文件，授权文件中应明确排他性、不可撤销性，开设旗舰店的时间应在授权期内；如超出授权期未继续获得授权的，则不得再使用“XX旗舰店”命名。",
      typeTile2:
        "以“XX（品牌名）专卖店”命名，品牌名应为已经注册的商标（R状态)或正在受理注册中的商标（TM状态，注册申请时间须满六个月），卖家应持有该品牌（商标）的权利人出具的销售该品牌商品的授权文件，如经营多个品牌的，各品牌应归同一实际控制人所有；如超出授权期未继续获得授权的，则不得再使用“XX专卖店”命名。",
      typeTile3:
        "以“XX（类目名）专营店”命名，卖家在同一一级类目下经营两个及以上品牌商品，卖家为商标权利人，或卖家持有相应品牌商标的权利人或商标权利人授权的代理人出具的销售授权书。",
      typeTile4:
        "经营多个行业、多个品牌、多个工厂货源的组货批发商，为采购买家提供一站式的多种需求的服务产品的供应商，企业经营范围含有申请相应品类，或能提供申请产品的生产、经营资质证书。",
      typeTile5:
        "以“XX（品牌名）直销店命名”的企业，须是国务院扶贫办公布的《国家级贫困县重点扶贫产品供应商名录》内的供应商，或是通过国家相关部门认证审核的具有带贫益贫效应的产品；申报时须提供企业相关资质证明（如卫生许可证、生产许可证）及相对应的扶贫佐证材料等。",
      typeTile6: '厂商资源店：以供应商名称命名，覆盖二级集采目录13大品类，例如型材、电线电缆、外加剂等',
      dialogVisible: false,
      categoryData: [{ categoryName: "请选择经营类目" }],
      titleData: [
        {
          name: "店长身份证",
          isDefault: 1,
          isDateInput: true,
          isShowDateInput: true,
        },
        {
          name: "法定代表人店铺授权委托书",
          isDefault: 1,
          isDateInput: true,
          isShowDateInput: true,
        },
        {
          name: "商标注册证/商品注册申请书/经销商授权书",
          isDefault: 1,
          isDateInput: true,
          isShowDateInput: true,
        },
      ],
      addQuaTemplate: [],
      saleLimitFlag: "",
      salesCategory: [{ categoryName: "请选择" }],
      areaData: [{ areaDataName: "请选择" }],
      scopeData: [{ scopeDataName: "请选择" }],
      salesRangeData: [{ categoryName: "请选择" }],
      cooperationType:[],
      canEdit: false,
      downFileUrl: this.$addUrlPerFix('sra.iccec.cn/apis/sra/store/users/signup/downloadTemplate'),
      form: {
        saleLimitArea:'',
        saleLimitAreaName:'',
        saleLimitUnit:'',
        saleLimitFlag:1,
        businessId: "",
        businessName: "",
        contactStr: "",
        businessShortname: "",
        unifiedCode: "",
        shopName: "",
        categoryData: "",
        salesCategory:'',
        scopeData:'',
        areaData:'',
        shopType: 1,
        shopAddress: "",
        supportPhone: "",
        shopSource: 1,
        shopBrief: "",
        shopManager: "",
        shopManagerPhone: "",
        shopManagerEmail: "",
        shopLogoUrl: "",
        uploadId: "",
        fileBos: [], // 邀请函附件
        isfileBos: "", // 邀请函附件
        contractCommonShopBO: {}
      },
      rules: {
        businessShortname: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
        ],
        unifiedCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
        ],
        shopManagerEmail: [
          {
            validator: validators.email,
            message: "请输入正确格式的E-mail",
            trigger: "blur",
          },
        ],
        shopManagerPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的手机号码",
            trigger: "blur",
          },
        ],
        shopType: [
          { required: true, message: "请选择店铺类型", trigger: "blur" },
        ],
        shopManager: [
          { required: true, message: "请输入店长的真实姓名", trigger: "blur" },
        ],
        shopBrief: [
          { required: true, message: "请输入店铺简介", trigger: "blur" },
        ],
        supportPhone: [
          { required: true, message: "请输入客服电话", trigger: "blur" },
          {
            validator: validators.minMobile,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
        shopAddress: [
          { required: true, message: "请输入店铺经营地址", trigger: "blur" },
        ],
        categoryData: [
          { required: true, message: "请选择经营类目", trigger: "change" },
          // {
          //   validator: (rule, value, callback) => {
          //     console.log("🚀 ~ data ~ value:", value)
          //     if(value.some(item => item.categoryName === '请选择经营类目')) {
          //       callback(new Error('请选择经营类目'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   message: "请选择经营类目",
          //   trigger: "change"
          // }
        ],
        shopName: [
          { required: true, message: "请输入店铺名称", trigger: "blur" },
        ]
      },
      manageCode: "",
      submitParams: {},
      businessName: "",
      agreementModal: false,
      query: {},
      shopInfo: {},
      defaultCategory: [],
      isShowBusinessFile: true,
    };
  },
  activated() {
    this.businessId = sessionStorage.getItem('businessId') || ''

    // this.$store.dispatch('cacheFunc', { type: 2, pageNameArr: ['applyShopInfo'] })
  },
  computed: {
    reload() {
      return this.$store.state.app.reload;
    },
    resultInfo() {
      return this.$store.state.app.resultInfo;
    },
    decryptBusinessId() {
      return this.$crypto.Decrypt(this.businessId);
    },
  },
  watch: {
    businessId(value) {
      console.log("🚀 ~ businessId ~ value:", value)
    }
  },
  created() {
    const orderPurchaseType = sessionStorage.getItem('orderPurchaseType')
    if (orderPurchaseType === '0') {
      this.rules.isfileBos = [
        { required: true, message: "请上传邀请函附件", trigger: "blur" },
      ]
    }
  },
  mounted() {
    this.$store.commit("ADD_CACHED_VIEW", { name: "applyShopInfo" });
    const orderPurchaseType = sessionStorage.getItem('orderPurchaseType')
    if (orderPurchaseType) {
      this.form.shopType = orderPurchaseType === '0' ? 10 : 11
      const cooperationType = orderPurchaseType === '0' ? '4' : '5'
      this.cooperationType = [cooperationType]
      sessionStorage.removeItem('orderPurchaseType') // TODO: 先删除店铺类型
    }
    this.mountedFn();
    this.shopCode = Cookies.get("shopCode");
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, "离开了");
    this.deleteLoad();
    next();
  },
  methods: {

    getQryOrgTree,
    queryMemberGroup,
    qryNonCCCCDeveloperInfo,
    selectRegionClick() {
      this.dialogarea = true;
    },
    handleAreaSelect(r) {
      console.log(r, "---");
      let arr = [],
        applyAreaDetail = [];

      if (JSON.stringify(r).indexOf("全国") < 0) {
        console.log(123);
      } else {
        applyAreaDetail.push("全国");
        // arr.push("全国");
      }
      r.forEach(item => {
        let codeArr = [];
        // let code = item.pcode2.split("-");
        if (item.name) {
          applyAreaDetail.push(item.cityName ? item.cityName : item.name);
        }
        codeArr.push(item.pcode2);
        if (item.name) {
          //回显时传给组件的值组件又带回来了们需要去掉
          arr.push(codeArr.join(","));
        }
      });
      if (!r.length){
        this.areaData = [{ areaDataName: "请选择" }];
      }else {
        let saleLimitArea=[]
        let scopeArr = [];
        let saleLimitAreaName = [];
        r.forEach(z=>{
          saleLimitArea.push(z.code);
          saleLimitAreaName.push(z.cityName)
        })
        arr.forEach(i => {
          scopeArr.push(i.abbrName);

        });
        console.log(saleLimitArea,'saleLimitArea')
        this.form.saleLimitArea = saleLimitArea.filter(v => v).join(',')
        this.form.saleLimitAreaName = saleLimitAreaName.filter(v => v).join(',')
        applyAreaDetail = applyAreaDetail.join("/");
        this.areaData[0].areaDataName = applyAreaDetail;
      }
      if (
        this.areaData &&
        this.areaData[0].areaDataName !== "请选择"
      ) {
        console.log(11111)
        this.form.areaData = "有数据";
        //清除校验
        this.$refs["form"].clearValidate("areaData");
      } else {
        this.form.areaData = ""; //添加校验
        this.$refs["form"].validateField("areaData");
      }

      console.log(applyAreaDetail, "applyAreaDetail");
      // // console.log(this.purchaseList)
    },
    categoryCode(data){
      console.log(data,'classifyBos')
      this.classifyBos=data
    },
    mergedStringArray(data) {
      console.log(data,'mergedStringArray')

      this.salesCategory = data;
      if (!data.length){
        this.salesCategory = [{ categoryName: "请选择" }];
      }
      if (
        this.salesCategory &&
        this.salesCategory[0].categoryName !== "请选择"
      ) {
        console.log(11111)
        this.form.salesCategory = "有数据";
        //清除校验
        this.$refs["form"].clearValidate("salesCategory");
      } else {
        this.form.salesCategory = ""; //添加校验
        this.$refs["form"].validateField("salesCategory");
      }
      console.log(data, "---");
      data.forEach(i => {
        i = { categoryName: i };
      });

    },
    selectedStaffSuccess(arr) {
      this.selectedData = arr
      console.log(arr, "----");
      if (!arr.length) {
        this.scopeData = [{ scopeDataName: "请选择" }];
      } else {
        let saleLimitUnit = [];
        let saleLimitUnitName = [];
        arr.forEach(i => {
          saleLimitUnitName.push(i.name);

          saleLimitUnit.push(i.autoCode);
        });

        this.scopeData[0].scopeDataName = saleLimitUnitName.join("/");
        this.form.saleLimitUnit = saleLimitUnit.join(",");
      }

      if (this.scopeData && this.scopeData[0].scopeDataName !== "请选择") {
        console.log(11111);
        this.form.scopeData = "有数据";
        //清除校验
        this.$refs["form"].clearValidate("scopeData");
      } else {
        this.form.scopeData = ""; //添加校验
        this.$refs["form"].validateField("scopeData");
      }
    },
    onFileDelete() {
      this.imageUrl = "";
      this.form.uploadId = "";
      this.form.shopLogoUrl = "";
    },
    allStrTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    regSpace(key) {
      this.form[key] = this.form[key].replace(/\s+/g, "");
    },
    handleClose(done) {
      done();
    },
    // 查看协议
    agreementClick() {
      this.agreementModal = true;
    },
    // 社会信用代码输入
    creditCodeChange(val) {
      if (val) {
        this.$eventBus.$emit("isCheckFile", "no");
      } else {
        this.$eventBus.$emit("isCheckFile", "check");
      }
    },
    mountedFn() {
      sessionStorage.removeItem('contractCommonShopBO')
      let getBusinessName = sessionStorage.getItem("businessName");
      if (this.reload) {
        this.deleteLoad();
        this.$router.replace("/business-open-shop/ready-data");
        return false;
      }
      this.$store.commit("RELOAD_SET", true);
      this.query = JSON.parse(sessionStorage.getItem("query"));
      console.log(this.query, "this.query");
      if (getBusinessName) {
        this.form.businessName = getBusinessName;
        this.getQryBusinessInfo()
      }
      // 编辑时查询店铺信息
      if (!isNaN(Number(this.resultInfo.shopState))) {
        this.qryShopInfo();
      }
      window.onbeforeunload = this.onbeforeunload;
      // window.addEventListener('beforeunload', e => this.onbeforeunload(e))
    },
    getQryBusinessInfo() {
      getQryBusinessInfo({
        compName: this.form.businessName,
        shopType: this.form.shopType,
        isShowLoading: true,
      })
        .then((res) => {
          if (res.data.code === "0" && res.data.data.businessName) {
            const emVendorInfo = JSON.parse(
              sessionStorage.getItem("emVendorInfo")
            );
            const { businessShortname, unifiedCode, flag } = res.data.data;
            this.canEdit = !!flag;
            if (emVendorInfo) {
              this.form.businessName = emVendorInfo.vendorNameCn;
              this.form.businessShortname = emVendorInfo.vendorSortName;
              this.form.unifiedCode = emVendorInfo.unifySocialCreditCodes;
              sessionStorage.removeItem("emVendorInfo")
            } else {
              this.form.businessShortname = businessShortname;
              this.form.unifiedCode = unifiedCode;
            }
            if (res.data.data.businessId) {
              this.businessId = res.data.data.businessId;
            }
          }
          if (
            res.data.code === "0" &&
            (res.data.data.businessName === undefined ||
              res.data.data.businessName === "")
          ) {
            const emVendorInfo = JSON.parse(
              sessionStorage.getItem("emVendorInfo")
            );
            if (emVendorInfo) {
              this.form.businessName = emVendorInfo.vendorNameCn;
              this.form.businessShortname = emVendorInfo.vendorSortName;
              this.form.unifiedCode = emVendorInfo.unifySocialCreditCodes;
              sessionStorage.removeItem("emVendorInfo")
            }
            getQryBusinessInfoByTyc({
              compName: this.form.businessName,
              isShowLoading: true,
            }).then((res) => {
              if (res.data.code === "0") {
                const { businessShortName, creditCode } = res.data.data;
                if (businessShortName) this.form.businessShortname = businessShortName;
                if (creditCode) this.form.unifiedCode = creditCode;
                this.canEdit = !!businessShortName;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteLoad() {
      window.removeEventListener("beforeunload", (e) => this.onbeforeunload(e));
      //window.onbeforeunload = null
    },
    onbeforeunload(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "关闭提示";
      }
      // this.$router.push('/business-shop/apply-shop/input-business-name')
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "关闭提示";
    },
    // 删除资质文件
    deleteClick(idx) {
      this.addQuaTemplate.splice(idx, 1);
      // this.$refs.uploadTemplate.splice(idx + this.titleData.length, 1)
      console.log(this.$refs.uploadTemplate, "this.$refs.uploadTemplate");
      console.log(this.addQuaTemplate, "this.addQuaTemplate");
    },
    uploadSuccess(fileList) {
      console.log("🚀 ~ uploadSuccess ~ fileList:", fileList)
      this.form.fileBos = fileList.map((el) => {
        return {
          // aptitudeName: el.fileName, //资质名称
          aptitudeName: '邀请函', //资质名称
          aptitudeUrl: el.downloadUrl, //文件地址
          fileName: el.fileName, //文件名称
          uploadId: el.uploadId, //上传文件id
          uploadTime: el.updateTime, //上传时间
          isLongValidity: 1, //是否长期有效: 0-否 1-是
          isDefault: 1, //是否默认: 0-否 1-是
        };
      });
      this.form.isfileBos = this.form.fileBos.length ? 1 : "";
      this.$refs["form"].validateField("isfileBos");
    },
    // 添加资质事件
    addQuaBtn() {
      let now = Date.now();
      this.addQuaTemplate.push({
        name: "公司资质",
        isAdd: true,
        isShowDateInput: true,
        isDefault: 0,
        id: now,
      });
      console.log(this.addQuaTemplate);
    },
    copyObj(target, obj) {
      for (let key in obj) {
        for (let targetKey in target) {
          if (key === targetKey) {
            target[targetKey] = obj[key];
          }
        }
      }
    },
    getCodeList() {
      // 提交时经营类目重组
      let list = [];
      this.defaultPitchOn.map(item1 => {
        if (item1.isSelected === true || item1.isSelected === "1") {
          // 有选中便利下一级
          item1.shopSecondCategoryBOS.map(item2 => {
            if (item2.isSelected === true || item2.isSelected === "1") {
              // 有选中便利下一级
              item2.shopThirdCategoryBOS.map(item3 => {
                if (item3.isSelected === true || item3.isSelected === "1") {
                  // 当前项选中
                  list.push({
                    categoryCode: item3.categoryCode,
                    categoryName: item3.categoryName
                  });
                }
              });
            }
          });
        }
      });
      console.log(list, "最终提交的三级经营编码");
      return list;
    },
    // 查询店铺信息
    qryShopInfo() {
      qryShopInfo({ shopId: this.resultInfo.shopId, isShowLoading: true }).then(
        (res) => {
          if (res.data.code === "0") {
            this.shopInfo = res.data.data;
            this.imageUrl = res.data.data.shopLogoUrl;
            this.shopId = res.data.data.shopId
            this.selectedData = res.data.data.saleLimitUnits
            this.shopManageClassifyCodeBos = res.data.data.classifyBos
            const { businessContactBO = {} } = res.data.data
            const { contactName, contactMobile } = businessContactBO
            if (contactName) this.form.contactStr =  `${contactName}(${contactMobile})`
            if (res.data.data.cooperationType != 9) {
              this.cooperationType = [String(res.data.data.cooperationType)]
            }
            let liat1 = []
            res.data.data.classifyBos.forEach(item => {
              liat1.push({
                categoryName: item.classifyNames
              })
            })
            let scopeDataName  = ""
            const { saleLimitUnits } = res.data.data
            if (saleLimitUnits && saleLimitUnits.length) {
              scopeDataName = saleLimitUnits.map(item => item.unitName).join("/")
            }
            if (liat1.length) this.salesCategory = liat1
            if (scopeDataName) this.scopeData = [{ scopeDataName }]
            //经营类目数据反显
            if (
              res.data.data.categoryBos &&
              res.data.data.categoryBos.length > 0
            ) {
              this.dataShowEdit(
                JSON.parse(JSON.stringify(res.data.data.categoryBos))
              );
            }
            this.form.saleLimitArea = res.data.data.saleLimitArea
            this.form.saleLimitAreaName = res.data.data.saleLimitAreaName
            if (res.data.data.saleLimitAreaName) {
              this.areaData = [
                {
                  areaDataName: res.data.data.saleLimitAreaName
                }
              ]
            }
            this.reShowArea(res.data.data.saleLimitArea)
            this.titleData = [];
            this.addQuaTemplate = [];
            res.data.data.shopAptitudeInfoBOS.forEach((item) => {
              let fileBos = {
                id: item.aptitudeInfoId,
                isDefault: item.isDefault,
                isAdd: !item.isDefault,
                name: item.aptitudeName,
                isDateInput: item.isDefault,
                isShowDateInput: true,
                fileList: [],
              };
              if (item.aptitudeUrl) {
                fileBos.fileList.push(
                  {
                    name: item.aptitudeName,
                    url: item.aptitudeUrl,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          uploadId: item.uploadId,
                          downloadUrl: item.aptitudeUrl,
                        },
                      ],
                    },
                  },
                );
                fileBos.fileList[0].response.data[0].uploadId = item.uploadId;
                fileBos.fileList[0].response.data[0].fileAddress =
                  item.networkAddress;
                fileBos.fileList[0].response.data[0].validityStart =
                  item.effectBeginTime;
                fileBos.fileList[0].response.data[0].validityEnd =
                  item.effectEndTime;
                fileBos.fileList[0].response.data[0].website =
                  item.networkAddress;
                fileBos.fileList[0].response.data[0].isLongValidity =
                  item.isLongTime;
              }
              if (item.aptitudeName == '邀请函') {
                let extension = ''
                const url = item.aptitudeUrl.split('?');
                if (url.length) {
                  const index = url[0].lastIndexOf('.')
                  if (index > 0) {
                    extension = url[0].substring(index + 1)
                  }
                }
                this.$refs.fileUploadRef.setFileList([
                  {
                    fileName: item.aptitudeName + `.${extension}`,
                    downloadUrl: item.aptitudeUrl,
                    uploadId: item.uploadId,
                  },
                ]);
                res.data.data.fileBos = [{
                  aptitudeName: '邀请函', //资质名称
                  aptitudeUrl: item.aptitudeUrl, //文件地址
                  uploadId: item.uploadId, //上传文件id
                  isLongValidity: 1, //是否长期有效: 0-否 1-是
                  isDefault: 1, //是否默认: 0-否 1-是
                }]
                res.data.data.isfileBos = 1
              } else {
                if (item.isDefault) {
                  this.titleData.push(fileBos);
                } else {
                  this.addQuaTemplate.push(fileBos);
                }
              }
            });
            this.isShowBusinessFile = false;
            this.$nextTick(() => {
              this.isShowBusinessFile = true;
            });
            this.copyObj(this.form, res.data.data);
            this.classifyBos = res.data.data.classifyBos;
            const { contractCommonShopBO } = res.data.data;
            // 暂存合同信息
            if (contractCommonShopBO) sessionStorage.setItem('contractCommonShopBO', JSON.stringify(contractCommonShopBO))
          }
            console.log("🚀 ~ qryShopInfo ~ this.form:", {...this.form})
          console.log(res, "查询店铺信息");
        }
      );
    },
    //回显区域
    reShowArea(row) {
      let arr = []
      if (typeof row == 'string' && row != '') {
        row.split(',').forEach((item, index) => {
          // let pcode2 = "";
          // pcode2 += item.applyProvince;
          // if (item.applyCity) {
          //   pcode2 += "-" + item.applyCity;
          // }
          arr.push({
            checked: true,
            pcode2: item,
            pcode: item.split('-')[0],
            code: item.split('-')[item.split('-').length - 1],
            name: this.form.saleLimitAreaName.split(',')[index],
            cityName: this.form.saleLimitAreaName.split(',')[index]
          })
        })
      }
      this.distributorsInfo = arr
    },
    // 提交事件
    nextClick() {
      // TODO: 先跳过去
      // this.$router.push("/business-open-shop/contract-input-info");
      // this.$store.dispatch("businessOpenShopSetStep", 4);
      // return
      if (
        this.areaData.length > 0 &&
        this.areaData[0].areaDataName != '请选择'
      ) {
        this.form.areaData = true
      } else {
        this.form.areaData = ''
      }
      if (
        this.salesCategory.length > 0 &&
        this.salesCategory[0].categoryName != '请选择'
      ) {
        this.form.salesCategory = true
      } else {
        this.form.salesCategory = ''
      }
      if (
        this.scopeData.length > 0 &&
        this.scopeData[0].scopeDataName != '请选择'
      ) {
        this.form.scopeData = true
      } else {
        this.form.scopeData = ''
      }
      console.log(this.$refs.uploadTemplate, "this.$refs.uploadTemplate");
      this.form.businessId = this.businessId;
      let submitFormInfo = JSON.parse(JSON.stringify(this.form));
      delete submitFormInfo.eleAccount;
      delete submitFormInfo.eleAccountBank;
      delete submitFormInfo.shopId;
      if (this.query && this.query.eleAccount) {
        submitFormInfo.eleAccount = this.query.eleAccount;
        submitFormInfo.eleAccountBank = this.query.eleAccountBank;
      }
      if (!isNaN(Number(this.resultInfo.shopState))) {
        submitFormInfo.shopId = this.resultInfo.shopId;
      }
      if (this.cooperationType.length) {
        submitFormInfo.cooperationType = this.cooperationType[0]
      }else {
        delete submitFormInfo.cooperationType
      }
      delete submitFormInfo.categoryData;
      delete submitFormInfo.scopeData;
      delete submitFormInfo.salesCategory;
      delete submitFormInfo.areaData;
      let classifyBos = this.classifyBos
      if (this.classifyBos[0] && this.classifyBos[0].classifyCodes) {
        let codelist = []
        let a, b, c
        this.classifyBos.forEach(i => {
          a = i.classifyCodes.split(',')
          b = a[3].split('\\')
          c = a.splice(0, 3)
          for (let i = 0; i < b.length; i++) {
            codelist.push({ classifyCode: b[i] })
          }
        })
        classifyBos = codelist
      }
      let submitParams = {
        aptitudeInfoBos: [],
        shopBO: submitFormInfo,
        classifyBos,
        categoryBos: [],
        isShowLoading: true,
        loadingMessage: "保存中,请稍等...",
      };
      // if (!isNaN(Number(this.resultInfo.shopState)) && this.shopManageClassifyCodeBos.length) {
      //   let codelist = []
      //   let a, b, c
      //   // this.classifyBos.forEach(i => {
      //   this.shopManageClassifyCodeBos.forEach(i => {
      //     a = i.classifyCodes.split(',')
      //     b = a[3].split('\\')
      //     c = a.splice(0, 3)
      //     for (let i = 0; i < b.length; i++) {
      //       codelist.push({ classifyCode: b[i] })
      //     }
      //   })
      //   submitParams.classifyBos = codelist
      //   console.log("🚀 ~ nextClick ~ codelist:", codelist)
      // } else {
      //   submitParams.classifyBos = this.classifyBos
      //   console.log("🚀 ~ nextClick ~ classifyBos:", this.classifyBos)
      // }
      if(this.form.saleLimitFlag == 0){
        delete submitParams.classifyBos;
        delete submitParams.shopBO.saleLimitUnitName;
        delete submitParams.shopBO.saleLimitUnit;
        delete submitParams.shopBO.saleLimitAreaName;
        delete submitParams.shopBO.saleLimitArea;
      }else {
        const map = { salesCategory: '请选择销售品类', scopeData: '请选择适用范围', areaData: '请选择适用地区' }
        let errorMessage = ''
        Object.entries(map).some(([key, value]) => {
          if (!this.form[key]) {
            errorMessage = value
          }
          return !this.form[key]
        })
        if (errorMessage) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: errorMessage,
            ccuiCustom: true
          })
        }
      }
      if (this.categoryData.length === 0 || (this.categoryData.length === 1 && this.categoryData[0].categoryName === '请选择经营类目')) {
        return this.$message({
          showClose: true,
          type: 'error',
          message: '请选择经营类目',
          ccuiCustom: true
        })
      } else {
        this.form.categoryData = true
      }
      console.log(this.$refs.uploadTemplate, "上传图片");
      this.$eventBus.$emit("isCheck", "applyShopInfo");
      this.$refs["form"].validate();
      this.$nextTick(() => {
        const errorFormEl = document.body.querySelectorAll(".is-error");
        if (!errorFormEl.length) {
          //this.categoryBos经营类目的数据
          submitParams.categoryBos = this.getCodeList() ;
          this.$refs.uploadTemplate.forEach((item, idx) => {
            let obj = {
              isDefault: item.titleData.isDefault,
              aptitudeName: item.form.fileName
                ? item.form.fileName
                : item.titleData.name,
              networkAddress: item.form.website,
              effectBeginTime: item.form.startTime,
              effectEndTime: item.form.checked ? "" : item.form.endTime,
              isLongTime: item.form.checked,
              shopCategoryCode: item.form.fileName
                ? ""
                : item.titleData.shopCategoryCode,
            };
            if (item.fileList.length) {
              Object.assign(obj, {
                uploadId: item.fileList[0].response.data[0].uploadId,
                aptitudeUrl: item.fileList[0].response.data[0].downloadUrl,
                uploadTime: item.fileList[0].response.data[0].createTime,
              });
            }
            submitParams.aptitudeInfoBos.push(obj);
          });
          // 组件基本信息参数
          const { businessName, businessShortname, unifiedCode, fileBos } = submitFormInfo;
          submitParams.businessName = businessName;
          submitParams.businessShortname = businessShortname;
          submitParams.businessId = this.businessId;
          submitParams.unifiedCode = unifiedCode;
          // 组装邀请函参数
          if (fileBos.length) submitParams.aptitudeInfoBos.push(fileBos[0])
          this.submitParams = submitParams;
          //点击提交数据 当前流程是申请开店 下一个流程人工审核
          console.log(this.categoryData, submitParams, 'this.submitParams')
          this.$store.dispatch("saveTempStoreInfo", submitParams);
          this.$router.push("/business-open-shop/contract-input-info");
          this.$store.dispatch("businessOpenShopSetStep", 4);
        } else {
          document.documentElement.scrollTop = errorFormEl[0].offsetTop;
        }
      });
    },
    isLimit(){

      console.log(    this.form.saleLimitFlag,'    this.form.saleLimitFlag')
      if(this.form.saleLimitFlag==0){
        this.$confirm('请确认与采购单位签署协议不需要限制销售范围，否则开店审核将被驳回！', '限制销售范围确认', {
          distinguishCancelAndClose: true,
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          customClass: 'ccui-message-box-custom1'
        })
          .then(() => {
            this.form.saleLimitFlag=0
            this.titleData= [
              {
                name: "店长身份证",
                isDefault: 1,
                isDateInput: true,
                isShowDateInput: true,
              },
              {
                name: "法定代表人店铺授权委托书",
                isDefault: 1,
                isDateInput: true,
                isShowDateInput: true,
              },
              {
                name: "商标注册证/商品注册申请书/经销商授权书",
                isDefault: 1,
                isDateInput: true,
                isShowDateInput: true,
              }
            ]
          })
          .catch(action => {
            this.form.saleLimitFlag=1
            this.titleData= [
              {
                name: "店长身份证",
                isDefault: 1,
                isDateInput: true,
                isShowDateInput: true,
              },
              {
                name: "法定代表人店铺授权委托书",
                isDefault: 1,
                isDateInput: true,
                isShowDateInput: true,
              },
              {
                name: "商标注册证/商品注册申请书/经销商授权书",
                isDefault: 1,
                isDateInput: true,
                isShowDateInput: true,
              },
            ]
          });
      }else {
        this.titleData= [
          {
            name: "店长身份证",
            isDefault: 1,
            isDateInput: true,
            isShowDateInput: true,
          },
          {
            name: "法定代表人店铺授权委托书",
            isDefault: 1,
            isDateInput: true,
            isShowDateInput: true,
          },
          {
            name: "商标注册证/商品注册申请书/经销商授权书",
            isDefault: 1,
            isDateInput: true,
            isShowDateInput: true,
          },
        ]
      }
    },
    selectCategoryClick() {
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file, "水电费水电费");
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.uploadId = res.data[0].uploadId;
      this.form.shopLogoUrl = res.data[0].downloadUrl;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message({
          showClose: true,
          type: "error",
          message: "上传LOGO图片只能是 png 格式!",
          ccuiCustom: true,
        });
        return isJPG;
      } else if (!isLt2M) {
        this.$message({
          showClose: true,
          type: "error",
          message: "上传LOGO图片大小不能超过 2MB!",
          ccuiCustom: true,
        });
        return isLt2M;
      } else {
        const _this = this;
        const isSize = new Promise(function (resolve, reject) {
          const img = new Image();
          const _URL = window.URL || window.webkitURl;
          img.onload = function () {
            file.width = img.width; //图片宽度
            file.height = img.height; //图片高度
            const valid = img.width <= 200 && img.height <= 60; //上传图片尺寸判定
            valid ? resolve() : reject(new Error("error"));
          };
          img.src = _URL.createObjectURL(file);
        }).then(
          () => {
            return file;
          },
          () => {
            _this.$message({
              showClose: true,
              type: "error",
              message: "上传图片尺寸必须在200*60以内！",
              ccuiCustom: true,
            });
            // _this.$message.error('上传图片尺寸必须为200*60以内')
            return Promise.reject(new Error("error"));
          }
        );
        return isSize;
        // return isJPG && isLt2M && isSize
      }
    },
  },
};
</script>
<style>
.el-message-box__header .el-message-box__title{
  font-weight: 600!important;
  font-size: 13px!important;
}
</style>
<style scoped lang="scss">
@import "~@/styles/variables.scss";
.explain {
  display: inline-block;
  line-height: 16px;
  position: absolute;
  margin-left: 20px;
  color: #9b9b9b;
}
/deep/ .input-long {
  width: 410px;
}
.category-input-wrapper {
  display: flex;
  .category {
    margin-right: 20px;
    max-height: 146px;
    overflow-y: auto;
    border-radius: 3px;
    box-sizing: border-box;
    width: 410px;
    border: 1px solid #dcdfe6;
    padding: 2px 9px;
    color: #999999;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.2s;
    div {
      line-height: 25px;
    }
  }
  .selectClass {
    color: #4a4a4a;
  }
  .category:hover {
    border-color: #999;
  }
}
/deep/ .input-center {
  display: flex;
  align-items: center;
  .el-form-item__content {
    display: flex;
    align-items: center;
    margin-left: 0 !important;
  }
}
.tipRight {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
  > span {
    display: flex;
    align-items: flex-end;
  }
}
.introduce {
  font-size: 10px;
  div {
    margin-bottom: 5px;
    display: flex;
    align-items: flex-start;
    span {
      line-height: 14px;
    }
  }
}
.introduce span {
  color: $--breadcrumb-separator-color;
}
.introduce .blue {
  color: #0089ef;
}
.noteBusinessName {
  font-size: 13px;
  line-height: 17px;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  display: block;
  position: relative;
  height: 65px;
  box-sizing: border-box;
  > div {
    line-height: 10px;
  }
  .icon-ccui-camera {
    font-size: 21px;
    display: block;
    margin: 9px 0;
  }
}
/deep/ .avatar-uploader {
  width: 200px;
  height: 60px;
  color: rgba(153, 153, 153, 1);
  font-size: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
/deep/ .avatar {
  width: 64px;
  height: 64px;
  display: block;
}
.uploadNoteWrapper {
  /deep/ .el-form-item__content {
    display: flex;
  }
  .uploadNote {
    font-size: 13px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 17px;
    margin-left: 10px;
  }
}
.addQuaBtn {
  width: 296px;
  font-size: 13px;
  font-weight: 400;
  color: #ff142f;
  line-height: 18px;
  user-select: none;
  padding-left: 160px;
  padding-bottom: 20px;
  cursor: pointer;
  /deep/ .icon-ccui-add {
    padding-right: 6px;
  }
}
.auto-open-account {
  padding-left: 132px;
  display: flex;
  align-items: center;
  font-size: 13px;
  margin: 20px 0;
  .el-checkbox {
    margin-right: 10px;
  }
  .view-account {
    color: #4a4a4a;
    span {
      color: #0089ef;
      cursor: pointer;
    }
  }
}
.accountMoney {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
}

.account-note {
  line-height: 15px;
  margin-left: 33px;
  font-size: 13px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.13);
  border-radius: 2px;
  padding: 3px;
  > span {
    color: #0089ef;
  }
}
.agreementModalCss {
  color: #666666;
  font-size: 13px;
  padding: 0 50px;
  height: 530px;
  overflow-y: auto;
  /deep/ .title {
    display: block;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 600;
  }
  /deep/ > div:nth-of-type(1) {
    margin-bottom: 20px;
  }
  /deep/ > div:nth-of-type(2) {
    div {
      margin-top: 10px;
      margin-bottom: 5px;
    }
    span {
      display: block;
    }
  }
}
.ccui-app-container-detail2 {
  margin: 20px 0px 20px;
  padding: 21px 0px 0px;
}
.step-left-lyp {
  margin-right: 10px;
}
.step-right-lyp {
  margin-right: 0px;
  margin-left: 10px;
}
.footer-step-lyp {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
}
/deep/ .el-dialog--customize .el-dialog__body {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  max-height: 135vh !important;
}
.template {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #0089ef;
  line-height: 6px;
}
</style>
